import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectUser = (state: AppState) => state.user;

export const getUsers = () => createSelector(selectUser, (state) => state.users);
export const getUsersTotal = () => createSelector(selectUser, (state) => state.usersTotal);
export const getFilter = () => createSelector(selectUser, (state) => state.filter);
export const getCurrentUserSession = () => createSelector(selectUser, (state) => state.currentUserSession);
